module.exports = __webpack_public_path__ + "static/media/gas_bell.aa61839.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/gas_bell.mp3
// module id = 33ib
// module chunks = 74